import { useTranslation } from 'react-i18next';
import { P } from '@/design-system/palette';
import { exportAllData, downloadJson } from '@/data/export-import';

export function ErrorFallback() {
  const { t } = useTranslation();

  const handleReload = () => {
    window.location.reload();
  };

  const handleExport = async () => {
    try {
      const { data, filename } = await exportAllData();
      downloadJson(data, filename);
    } catch {
      // If export fails too, nothing we can do
    }
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100dvh',
      background: P.s0,
      color: P.t1,
      padding: 24,
      textAlign: 'center',
    }}>
      <div style={{ fontSize: 48, marginBottom: 16 }}>⚠</div>
      <h1 style={{ fontSize: 20, fontWeight: 600, marginBottom: 8 }}>
        {t('error.title')}
      </h1>
      <p style={{ fontSize: 14, color: P.t2, marginBottom: 32, maxWidth: 400 }}>
        {t('error.description')}
      </p>
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center' }}>
        <button
          onClick={handleReload}
          style={{
            padding: '10px 20px',
            borderRadius: 8,
            border: 'none',
            background: P.accent,
            color: P.s0,
            fontWeight: 600,
            fontSize: 14,
            cursor: 'pointer',
          }}
        >
          {t('error.reload')}
        </button>
        <button
          onClick={handleExport}
          style={{
            padding: '10px 20px',
            borderRadius: 8,
            border: `1px solid ${P.border}`,
            background: 'transparent',
            color: P.t1,
            fontWeight: 500,
            fontSize: 14,
            cursor: 'pointer',
          }}
        >
          {t('error.exportData')}
        </button>
      </div>
    </div>
  );
}
